import { render, staticRenderFns } from "./FirmMsg.vue?vue&type=template&id=7afe693f&scoped=true&"
import script from "./FirmMsg.vue?vue&type=script&lang=js&"
export * from "./FirmMsg.vue?vue&type=script&lang=js&"
import style0 from "./FirmMsg.vue?vue&type=style&index=0&id=7afe693f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afe693f",
  null
  
)

export default component.exports